import { Action } from '@ngrx/store';
import { ApplicationDetail } from '../model/application/application-detail.model';
import { ApplicationListDetail } from '../model/application/application-list-detail.model';
import { AccountGroup } from '../../../core/model/account-group/account-group.model';
import { Product } from '../../../core/model/account-group/product.model';

export const TOGGLE_DETAIL =              '[Application Detail] Toggle Detail';
export const REMOVE_DETAIL =              '[Application Detail] Remove Detail';
export const LOAD_REQUEST =               '[Application Detail] Load Request';
export const LOAD_SUCCESS =               '[Application Detail] Load Success';
export const LOAD_ERROR =                 '[Application Detail] Load Error';
export const TOGGLE_ACCOUNT_GROUP =       '[Application Detail] Toggle Account Group';
export const TOGGLE_ENABLE_PRODUCT =      '[Application Detail] Toggle Enable Product';
export const DELETE =                     '[Application Detail] Delete';
export const UPDATE_PERMISSIONS =         '[Application Detail] Update Permissions';
export const REVERT_PERMISSIONS_REQUEST = '[Application Detail] Revert Permissions Request';
export const REVERT_PERMISSIONS_FINISH =  '[Application Detail] Revert Permissions Finish';

/**
 * Request to load application detail.
 * Payload contains requested application id.
 */
export class LoadRequestAction implements Action {
    readonly type = LOAD_REQUEST;

    constructor(public payload: string) {}
}

/**
 * Application detail has been loaded.
 */
export class LoadSuccessAction implements Action {
    readonly type = LOAD_SUCCESS;

    constructor(public payload: ApplicationDetail) {}
}

/**
 * Action to trigger delete operation.
 */
export class DeleteAction implements Action {
    readonly type = DELETE;

    constructor(public payload: ApplicationListDetail) {}
}

/**
 * Action to remove detail from store.
 */
export class RemoveDetailAction implements Action {
    readonly type = REMOVE_DETAIL;

    constructor(public payload: ApplicationListDetail) {}
}

/**
 * Action to trigger Update / Set Permissions access to application accounts.
 */
export class UpdatePermissionsAction implements Action {
    readonly type = UPDATE_PERMISSIONS;

    /**
     * Constructor - payload contains application id.
     * @param {string} payload appId
     */
    constructor(public payload: string) {}
}

/**
 * Action request to cancel changes.
 */
export class RevertPermissionsRequestAction implements Action {
    readonly type = REVERT_PERMISSIONS_REQUEST;

    /**
     * Constructor - payload contains application id.
     * @param {string} payload appId
     */
    constructor(public payload: string) {}
}

/**
 * Action finish to cancel changes.
 */
export class RevertPermissionsFinishAction implements Action {
    readonly type = REVERT_PERMISSIONS_FINISH;

    constructor(public payload: ApplicationDetail) {}
}


export class LoadErrorAction implements Action {
    readonly type = LOAD_ERROR;

    constructor(public payload: any) {}
}

/**
 * Application detail is expanded / collapsed.
 */
export class ToggleDetailAction implements Action {
    readonly type = TOGGLE_DETAIL;

    constructor(public payload: ApplicationListDetail) {}
}

/**
 * Action to toggle account group visibility.
 */
export class ToggleAccountGroupAction implements Action {
    readonly type = TOGGLE_ACCOUNT_GROUP;

    constructor(public payload: ToggleAccountGroupPayload) {}
}

/**
 * Action payload appId: application identification and account group its visibility is being toggled.
 */
export class ToggleAccountGroupPayload {
    appId: string;
    accountGroup: AccountGroup;

    constructor(appId: string, accountGroup: AccountGroup) {
        this.appId = appId;
        this.accountGroup = accountGroup;
    }
}

/**
 * Action to toggle product enabled flag.
 */
export class ToggleEnableProductAction implements Action {
    readonly type = TOGGLE_ENABLE_PRODUCT;

    constructor(public payload: ToggleEnableProductPayload) {}
}

/**
 * Action payload appId: application identification and account group / product its ennbled flag is being toggled.
 */
export class ToggleEnableProductPayload extends ToggleAccountGroupPayload {
    product: Product;

    /**
     * We have to pass original groups to set initial value of modified groups.
     */
    originalGroups: AccountGroup[];

    constructor(appId: string, accountGroup: AccountGroup, product: Product) {
        super(appId, accountGroup);
        this.product = product;
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = ToggleDetailAction
    | RemoveDetailAction
    | LoadRequestAction
    | LoadSuccessAction
    | LoadErrorAction
    | ToggleAccountGroupAction
    | ToggleEnableProductAction
    | DeleteAction
    | UpdatePermissionsAction
    | RevertPermissionsRequestAction
    | RevertPermissionsFinishAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/actions/application-detail.actions.ts